import Link from "next/link";

export default function CTABanner() {
	return (
		<section className="py-16 md:py-20 bg-gray-100">
			<div className="container mx-auto px-4">
				<div className="max-w-5xl mx-auto text-center">
					<h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-900 mb-8 leading-tight">
						NEVER LET THE <span className="text-primary">FEAR</span> OF LOSING
						KEEP YOU FROM <span className="text-primary">WINNING</span> THE GAME
					</h2>

					<Link
						href="/registration"
						className="inline-block text-gray-900 font-bold text-lg md:text-xl uppercase tracking-wide hover:text-primary transition-colors relative group"
					>
						REGISTER NOW
						<span className="absolute bottom-0 left-0 w-full h-0.5 bg-gray-900 group-hover:bg-primary transition-colors"></span>
					</Link>
				</div>
			</div>
		</section>
	);
}
